import {OPEN_CLOSE_ACCUMULATOR_BOOST} from '../constants/actionTypes';

export default (state, action) => {
    switch (action.type) {
        case OPEN_CLOSE_ACCUMULATOR_BOOST:
            let newIsAccumulatorBoostPagesOpen = !state.isAccumulatorBoostPagesOpen;
            return {
                ...state,
                isAccumulatorBoostPagesOpen: newIsAccumulatorBoostPagesOpen
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/accumulatorBoostPagesReducer.js